






import { logRocket } from "@/common/utils";

export default {
  mounted() {
    logRocket();
    const searchBox = document.querySelector(".SearchBox") as HTMLElement;
    if (!searchBox) {
      return;
    }
    this.showSearchBox(searchBox);

    window.addEventListener("resize", function() {
      const searchBox = document.querySelector(".SearchBox") as HTMLElement;
      if (window.innerWidth <= 560) {
        searchBox && (searchBox.style.display = "none");
      } else {
        searchBox && (searchBox.style.display = "");
      }
    });
  },

  updated() {
    const searchBox = document.querySelector(".SearchBox") as HTMLElement;
    if (!searchBox) {
      return;
    }
    this.showSearchBox(searchBox);
  },

  methods: {
    showSearchBox(elm) {
      if (elm) {
        if (window.innerWidth <= 560) {
          elm.style.display = "none";
        } else {
          elm.style.display = "";
        }
      }
    },
  },
};
